import type { GridCard } from '@Components/BigBrowse/Model/Classes/GridCard';
import type { PlaneTypes } from '@Components/BigBrowse/Model/ModelTypes';
import { Assets } from '@Utils/AssetsStore';
import { Html } from '@react-three/drei';
import { observer } from 'mobx-react-lite';
import type { CSSProperties } from 'react';

import { TextPositioner } from '../primitives/TextPositioner';

type Props = {
  item: GridCard<PlaneTypes.Card_SingleSectionView_Description>;
};

export const SingleSectionDescription = observer(
  function SingleSectionDescription({ item }: Props) {
    const fontSize = item.size.width >= 590 ? 36 : 26;

    const wrapperStyle: CSSProperties = {
      width: item.size.width,
      height: item.size.height,
      pointerEvents: 'none',
    };

    const titleStyle: CSSProperties = {
      fontSize,
      fontFamily: Assets.Font_Gilroy_Bold,
      textAlign: 'center',
      color: 'black',
      letterSpacing: fontSize * 0.03,
      lineHeight: 1.22,
    };

    const bodyStyle: CSSProperties = {
      marginTop: 15,
      fontSize: 18,
      fontFamily: Assets.Font_Gilroy_Bold,
      color: 'black',
      letterSpacing: 18 * 0.03,
      lineHeight: 22 / 18,
    };

    return (
      <TextPositioner item={item}>
        <Html center zIndexRange={[0, 0]} style={wrapperStyle}>
          <div style={titleStyle}>{item.data?.title}</div>
          <div style={bodyStyle}>{item.data?.body}</div>
        </Html>
      </TextPositioner>
    );
  }
);
